import styled from 'styled-components';
import { btnReset } from '../../helpers/style-helpers';

export const ModalSC = styled.div`
  position: relative;
  padding: 64px;
  width: 700px;
  max-width: 90vw;

  transition: padding 0.2s;

  .modal-close {
    ${btnReset}

    background: transparent;
    position: absolute;
    top: 24px;
    right: 24px;

    img {
      width: 12px;
      height: 12px;
    }
  }

  @media screen and (max-width: 992px) {
    padding: 32px;
  }
`;

export const ModalTitleSC = styled.h2`
  color: #141b38;
  font-size: 24px;
  font-weight: 300;
  line-height: 32px;
  margin-bottom: 8px;
`;

export const ModalCopySC = styled.p`
  line-height: 24px;
  color: rgba(20, 27, 56, 0.4);
  margin-bottom: 24px;
`;
